import { ArrowLeft, MoreHorizontal } from 'lucide-react'
import { Avatar } from '../ui/Avatar'

interface AgentProfileHeaderProps {
    agent: {
        name: string
        handle: string | null
        avatar_url?: string | null
        banner_url?: string | null
    }
    onBack: () => void
    onChat: () => void
    onConfigure: () => void
    onEditProfile?: () => void
}

export function AgentProfileHeader({ agent, onBack, onChat, onConfigure, onEditProfile }: AgentProfileHeaderProps) {
    return (
        <div className="relative">
            {/* Banner */}
            <div className="h-[200px] md:h-[200px] bg-gradient-to-br from-yellow-200 via-pink-200 to-blue-200 overflow-hidden relative">
                {agent.banner_url && (
                    <img
                        src={agent.banner_url}
                        alt="Banner"
                        className="w-full h-full object-cover"
                    />
                )}

                {/* Botão Voltar - Sobre o banner */}
                <button
                    onClick={onBack}
                    className="absolute top-2 left-2 z-10 flex items-center justify-center w-8 h-8 text-white hover:bg-white/10 rounded-full transition-colors backdrop-blur-sm"
                >
                    <ArrowLeft className="w-5 h-5" />
                </button>

            </div>

            {/* Container com Avatar e Botões lado a lado */}
            <div className="px-4 flex items-start justify-between">
                {/* Avatar sobreposto */}
                <div className="relative -mt-[67px] group">
                    <div className="w-[133px] h-[133px] rounded-full p-[4px] bg-gradient-to-br from-blue-400 via-purple-500 to-pink-400 relative">
                        <div className="w-full h-full rounded-full overflow-hidden bg-white dark:bg-black">
                            <Avatar
                                size="xl"
                                className="w-full h-full"
                                alt={agent.name}
                                src={agent.avatar_url || undefined}
                            />
                        </div>
                    </div>
                </div>

                {/* Botões de ação - Lado direito, abaixo do banner */}
                <div className="flex gap-2 mt-3">
                    <button
                        onClick={onEditProfile}
                        className="p-2 border border-gray-300 dark:border-gray-700 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                    >
                        <MoreHorizontal className="w-5 h-5" />
                    </button>
                    <button
                        onClick={onChat}
                        className="px-4 py-2 bg-white dark:bg-gray-100 text-black border border-gray-300 dark:border-gray-400 rounded-full font-bold text-[15px] hover:bg-gray-100 dark:hover:bg-gray-200 transition-colors"
                    >
                        Conversar
                    </button>
                    <button
                        onClick={onConfigure}
                        className="px-4 py-2 bg-black dark:bg-white text-white dark:text-black rounded-full font-bold text-[15px] hover:bg-gray-900 dark:hover:bg-gray-100 transition-colors"
                    >
                        Configurar
                    </button>
                </div>
            </div>
        </div>
    )
}
